module.exports = __webpack_public_path__ + "static/media/trampas-02.4e51e925.png";